<template lang="">
  <v-container
    v-if="
      user.permissions.indexOf(permissionsAll.project_create) >= 0 ||
        user.person.types_person.id === 3
    "
  >
    <BreadCrumbs :items="itemsBreadCrumbs" />
    <FormProject
      :actionForm="actionForm"
      @sendForm="sendForm"
      ref="formComponent"
    />
  </v-container>
</template>
<script>
import { beginRequest, endRequest, itemsBreadCrumbs } from "../../helpers";
import { BreadCrumbs } from "../../components/_commons";
import { FormProject } from "../../components/project";
import { mapState } from "vuex";
import permissions from "../../helpers/permissions";

export default {
  name: "ProjectCreate",
  components: {
    BreadCrumbs,
    FormProject,
  },
  data() {
    return {
      itemsBreadCrumbs: itemsBreadCrumbs.projectCreate,
      actionForm: "create",
      permissionsAll: permissions,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    async sendForm(formData) {
      await beginRequest();
      const { status, snack } = await this.$store.dispatch(
        "createProjectAction",
        formData
      );
      if (status >= 200 && status < 300) {
        this.$refs.formComponent.resetFormMethod();
      }
      await endRequest(snack, status);
    },
  },
  async created() {
    await this.$store.dispatch("setProjectSelectedAction", null);
  },
};
</script>
